import React, { useEffect } from "react";
import { connect } from "react-redux";
import LeaveCard from "views/console/team-managements/components/LeaveCard";
import HeaderComponent from "components/card/HeaderComponent";
import { Calendar } from "lucide-react";




const UpcomingLeavesTable = () => {

	
return (
	<HeaderComponent
		title="Upcoming Leaves"
		description="Approved leave requests for the next 30 days"
		icon={<Calendar size={20}/>}
		colorTheme="flat-blue"
		bgcolor="bg-slate-50/50"
		shadow="shadow-sm"
		border="border-b"
	>
		<div className= "overflow-y-auto p-1 h-[500px]">
			<LeaveCard
			name="Saccharine Elupre"
			location="India"
			type="Sick Leave"
			fromDate="Oct 18, 2025"
			toDate="Oct 19, 2025"
			days={2}
			status="Approved"
			/>
			<LeaveCard
			name="Ashley Palma"
			location="Philippines"
			type="Vacation"
			fromDate="Oct 20, 2025"
			toDate="Oct 25, 2025"
			days={6}
			status="Approved"
			/>

			<LeaveCard
			name="Emily Rodriguez"
			location="Colombia"
			type="Vacation"
			fromDate="Oct 28, 2025"
			toDate="Nov 5, 2025"
			days={9}
			status="Approved"
			/>
			<LeaveCard
			name="Lisa Anderson"
			location="Sri Lanka"
			type="Personal"
			fromDate="Oct 22, 2025"
			toDate="Oct 22, 2025"
			days={1}
			status="Approved"
			/>	
		</div>
	</HeaderComponent>
	
  );
};

const mapStateToProps = (state) => ({
	// recordList: state.trainingClass.trainingClassList?.items,
	// pagination: state.trainingClass.trainingClassList?.pagination,
	// filters: state.trainingClass.trainingClassList?.filters,
	// requesting: state.trainingClass.trainingClassList?.requesting,
	// error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	// doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	// doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	// doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpcomingLeavesTable);
